import { usePapeisObrigatorios } from "./use-papeis-obrigatorios";
import { PapeisObrigatoriosView } from "./view-papeis-obrigatorios";
import type { PapeisObrigatoriosProps } from "./types-papeis-obrigatorios";

export function PapeisObrigatorios(props: PapeisObrigatoriosProps) {
  const vm = usePapeisObrigatorios(props);

  return <PapeisObrigatoriosView {...vm} />;
}

export type { PapeisObrigatoriosProps } from "./types-papeis-obrigatorios";
